/**
 * @flow
 * @relayHash 0cffb05229d7af636b7862e942d03928
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type ShipmentStatus = "DELIVERED" | "DRAFT" | "READY" | "SHIPPED";
export type ShipmentQueryVariables = {|
  id?: ?string
|};
export type ShipmentQueryResponse = {|
  +shipment: {|
    +id: string,
    +shipmentNumber: string,
    +status: ShipmentStatus,
    +carrierName: ?string,
    +trackingNumber: ?string,
    +shippingMethod: ?string,
    +shippingAddressLine1: ?string,
    +shippingAddressLine2: ?string,
    +shippingAddressLine3: ?string,
    +shippingAddressCity: ?string,
    +shippingAddressState: ?string,
    +shippingAddressZip: ?string,
    +estimatedShipDate: ?any,
    +actualShipDate: ?any,
    +estimatedDeliveryDate: ?any,
    +actualDeliveryDate: ?any,
    +notes: ?string,
    +packageWeight: ?number,
    +packageLength: ?number,
    +packageWidth: ?number,
    +packageHeight: ?number,
    +shippingCost: ?number,
    +serviceType: ?string,
    +serviceName: ?string,
    +shippingLabelUrl: ?string,
    +upsShipmentId: ?string,
    +trackingEvents: $ReadOnlyArray<{|
      +id: string,
      +status: string,
      +description: ?string,
      +location: ?string,
      +eventTimestamp: ?any,
    |}>,
    +order: {|
      +id: string,
      +orderNumber: string,
      +status: OrderStatus,
      +customer: {|
        +id: string,
        +name: string,
      |},
    |},
    +customer: {|
      +id: string,
      +name: string,
    |},
    +items: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: {|
          +id: string,
          +quantity: number,
          +description: ?string,
          +item: {|
            +id: string,
            +name: string,
            +itemNumber: string,
            +lotTracking: ?boolean,
            +quantityUOM: {|
              +id: string,
              +symbol: string,
            |},
          |},
          +createdAt: any,
          +serials: ?$ReadOnlyArray<?{|
            +id: string,
            +serialNumber: string,
          |}>,
          +picks: ?$ReadOnlyArray<?{|
            +id: string,
            +quantity: number,
            +pickedAt: ?any,
            +lot: ?{|
              +id: string,
              +lotNumber: string,
            |},
            +pickedBy: ?{|
              +id: string,
              +firstName: string,
              +lastName: string,
            |},
          |}>,
          +pickedQuantity: number,
          +fullyPicked: boolean,
        |}
      |}>
    |},
    +updatedAt: any,
    +createdAt: any,
  |},
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
    +company: {|
      +id: string,
      +name: ?string,
      +addressLine1: ?string,
      +addressLine2: ?string,
      +addressCity: ?string,
      +addressState: ?string,
      +addressZip: ?string,
      +addressCountry: ?string,
      +phone: ?string,
    |},
  |},
|};
export type ShipmentQuery = {|
  variables: ShipmentQueryVariables,
  response: ShipmentQueryResponse,
|};
*/


/*
query ShipmentQuery(
  $id: ID
) {
  shipment(id: $id) {
    id
    shipmentNumber
    status
    carrierName
    trackingNumber
    shippingMethod
    shippingAddressLine1
    shippingAddressLine2
    shippingAddressLine3
    shippingAddressCity
    shippingAddressState
    shippingAddressZip
    estimatedShipDate
    actualShipDate
    estimatedDeliveryDate
    actualDeliveryDate
    notes
    packageWeight
    packageLength
    packageWidth
    packageHeight
    shippingCost
    serviceType
    serviceName
    shippingLabelUrl
    upsShipmentId
    trackingEvents {
      id
      status
      description
      location
      eventTimestamp
    }
    order {
      id
      orderNumber
      status
      customer {
        id
        name
      }
    }
    customer {
      id
      name
    }
    items(first: 1000) {
      edges {
        node {
          id
          quantity
          description
          item {
            id
            name
            itemNumber
            lotTracking
            quantityUOM {
              id
              symbol
            }
          }
          createdAt
          serials {
            id
            serialNumber
          }
          picks {
            id
            quantity
            pickedAt
            lot {
              id
              lotNumber
            }
            pickedBy {
              id
              firstName
              lastName
            }
          }
          pickedQuantity
          fullyPicked
        }
      }
    }
    updatedAt
    createdAt
  }
  viewer {
    id
    permissions
    company {
      id
      name
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
      phone
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "customer",
  "storageKey": null,
  "args": null,
  "concreteType": "Customer",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v4/*: any*/)
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shipment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Shipment",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shipmentNumber",
        "args": null,
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "carrierName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "trackingNumber",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingMethod",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingAddressLine1",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingAddressLine2",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingAddressLine3",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingAddressCity",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingAddressState",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingAddressZip",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "estimatedShipDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "actualShipDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "estimatedDeliveryDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "actualDeliveryDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "packageWeight",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "packageLength",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "packageWidth",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "packageHeight",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingCost",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingLabelUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "upsShipmentId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "trackingEvents",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentTrackingEvent",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "eventTimestamp",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": null,
        "concreteType": "Order",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "orderNumber",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/),
          (v5/*: any*/)
        ]
      },
      (v5/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": "items(first:1000)",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1000
          }
        ],
        "concreteType": "ShipmentItemConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ShipmentItemEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentItem",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "itemNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lotTracking",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "quantityUOM",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UOM",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "symbol",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "serials",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSerial",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "serialNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "picks",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentPick",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pickedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "lot",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Lot",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lotNumber",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pickedBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastName",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pickedQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fullyPicked",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "updatedAt",
        "args": null,
        "storageKey": null
      },
      (v7/*: any*/)
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "permissions",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "company",
        "storageKey": null,
        "args": null,
        "concreteType": "Company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine1",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine2",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressCity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressState",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressZip",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressCountry",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ShipmentQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v8/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ShipmentQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v8/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ShipmentQuery",
    "id": null,
    "text": "query ShipmentQuery(\n  $id: ID\n) {\n  shipment(id: $id) {\n    id\n    shipmentNumber\n    status\n    carrierName\n    trackingNumber\n    shippingMethod\n    shippingAddressLine1\n    shippingAddressLine2\n    shippingAddressLine3\n    shippingAddressCity\n    shippingAddressState\n    shippingAddressZip\n    estimatedShipDate\n    actualShipDate\n    estimatedDeliveryDate\n    actualDeliveryDate\n    notes\n    packageWeight\n    packageLength\n    packageWidth\n    packageHeight\n    shippingCost\n    serviceType\n    serviceName\n    shippingLabelUrl\n    upsShipmentId\n    trackingEvents {\n      id\n      status\n      description\n      location\n      eventTimestamp\n    }\n    order {\n      id\n      orderNumber\n      status\n      customer {\n        id\n        name\n      }\n    }\n    customer {\n      id\n      name\n    }\n    items(first: 1000) {\n      edges {\n        node {\n          id\n          quantity\n          description\n          item {\n            id\n            name\n            itemNumber\n            lotTracking\n            quantityUOM {\n              id\n              symbol\n            }\n          }\n          createdAt\n          serials {\n            id\n            serialNumber\n          }\n          picks {\n            id\n            quantity\n            pickedAt\n            lot {\n              id\n              lotNumber\n            }\n            pickedBy {\n              id\n              firstName\n              lastName\n            }\n          }\n          pickedQuantity\n          fullyPicked\n        }\n      }\n    }\n    updatedAt\n    createdAt\n  }\n  viewer {\n    id\n    permissions\n    company {\n      id\n      name\n      addressLine1\n      addressLine2\n      addressCity\n      addressState\n      addressZip\n      addressCountry\n      phone\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e0c4a84e6b94047664eb419da8175caf';
module.exports = node;
